import * as React from "react";

import OverlayMenuItem from "./OverlayMenuItem";

const OverlayMenu: React.SFC<any> = ({ className, items }) => (
  <div className={className}>
    {items.map((item, index) => {
      return item.desktopOnly ? null : (
        <OverlayMenuItem key={item.label + index} href={item.href}>
          {item.label}
        </OverlayMenuItem>
      );
    })}
  </div>
);

export default OverlayMenu;
